<bread-crumb></bread-crumb>

<h2 class="v_center">
    {{ 'audit.change_log' | translate }} 
</h2>


<mat-card class="card width-field-100 b_space">
    <mat-card-content class="card-content">
        <form #f = "ngForm">

         <div fxLayout="row">

            <mat-form-field  fxFlex = "20">
                <mat-label> {{ 'generic.date_from' | translate }} </mat-label>
                <input matInput [matDatepicker]="picker_from" [formControl]="audit_search.date_from">
                <mat-datepicker-toggle matSuffix [for]="picker_from"></mat-datepicker-toggle>
                <mat-datepicker #picker_from></mat-datepicker>
            </mat-form-field>

            <mat-form-field fxFlex = "20" fxFlexOffset="2">
                <mat-label> {{ 'generic.date_to' | translate }} </mat-label>
                <input matInput [matDatepicker]="picker_to" [formControl]="audit_search.date_to">
                <mat-datepicker-toggle matSuffix [for]="picker_to"></mat-datepicker-toggle>
                <mat-datepicker #picker_to></mat-datepicker>
            </mat-form-field>

            <mat-form-field fxFlex = "20" fxFlexOffset="2">
                <mat-label> {{ 'generic.search' | translate }} </mat-label>
                <input matInput [(ngModel)] = "audit_search.probe" name="probe">
            </mat-form-field>

            <mat-form-field fxFlexOffset="2" fxFlex = "20">
                <mat-label> {{ 'audit.operation_result' | translate }} </mat-label>
                <mat-select [(ngModel)]="audit_search.operation_result" name="operation_result">
                    <mat-option *ngFor="let aa of audit_search.operation_result_choices; " [value]="aa.value">
                        {{ aa.name | translate }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <button mat-button color="primary" (click)="search()"> {{ 'generic.search' | translate }} </button>

          </div>

        </form>

    </mat-card-content>
</mat-card>

<mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>

<mat-paginator  class="mat-elevation-z1"
              [length]                  = "total_rows"
              [pageSize]                = "per_page"
              [pageSizeOptions]         = "[10, 20, 30, 40 , 50]"
              [showFirstLastButtons]    = true
              (page)                    = "onPaginateChange($event)" >
              >
</mat-paginator>

<table mat-table [dataSource]="audits" class="mat-elevation-z1" matSort (matSortChange)="sortData($event)" matSortActive="timestamp">

    <!-- Owner Column -->
    <ng-container matColumnDef="owner">
        <th mat-header-cell *matHeaderCellDef  mat-sort-header="operation_user" > {{ 'audit.owner' | translate }} </th>
        <td mat-cell *matCellDef="let element"> <i class="material-icons green" > {{ getOwnerIcon(element)  }} </i> </td>
    </ng-container>

    <!-- Timestamp Column -->
    <ng-container matColumnDef="timestamp">
        <th mat-header-cell *matHeaderCellDef  mat-sort-header="timestamp" > {{ 'audit.timestamp' | translate }} </th>
        <td mat-cell *matCellDef="let element"> {{ element.readable_timestamp  }} </td>
    </ng-container>

    <!-- object_type  -->
    <ng-container matColumnDef="object_type">
        <th mat-header-cell *matHeaderCellDef  mat-sort-header="object_type" > {{ 'audit.object_type' | translate }} </th>
        <td mat-cell *matCellDef="let element"> {{ element.object_type || "-"}} </td>
    </ng-container> 

    <!-- author -->
    <ng-container matColumnDef="author">
        <th mat-header-cell *matHeaderCellDef > {{ 'audit.operation_user' | translate }} </th>
        <td mat-cell *matCellDef="let element"> {{ element.operation_user || "-" }} </td>
    </ng-container> 

    <!-- operation_type  -->
    <ng-container matColumnDef="operation_type">
        <th mat-header-cell *matHeaderCellDef  > {{ 'audit.operation_type' | translate }} </th>
        <td mat-cell *matCellDef="let element" > {{ element.operation_type || "0"}} </td>
    </ng-container> 

    <!-- operation_result  -->
    <ng-container matColumnDef="operation_result">
        <th mat-header-cell *matHeaderCellDef  > {{ 'audit.operation_result' | translate }} </th>
        <td mat-cell *matCellDef="let element" > {{ element.readable_operation_result | translate }} </td>
    </ng-container> 

     <!-- operation_result icon -->
    <ng-container matColumnDef="operation_result_icon">
        <th mat-header-cell *matHeaderCellDef  > {{ 'audit.operation_result' | translate }} </th>
        <td mat-cell *matCellDef="let element" > <mat-icon [ngStyle] = "{ 'color' : element.icon_operation_result['color'] }" >  {{ element.icon_operation_result['icon'] }} </mat-icon> </td>
    </ng-container> 

    <!-- object name  -->
    <ng-container matColumnDef="object_name">
        <th mat-header-cell *matHeaderCellDef  mat-sort-header="object_name" > {{ 'audit.object_name' | translate }} </th>
        <td mat-cell *matCellDef="let element" > {{ element.object.name || "0"}} </td>
    </ng-container> 

    <ng-container matColumnDef="operation_info">
        <th mat-header-cell *matHeaderCellDef  mat-sort-header="detail" > {{ 'audit.detail' | translate }} </th>
        <td mat-cell *matCellDef="let element" > {{ element.operation_info || "--"}} </td>
    </ng-container> 

    <tr mat-header-row *matHeaderRowDef="displayed_columns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayed_columns;"></tr>
</table>

<div fxLayout="row" *ngIf="!audits.length" class="mat-elevation-z1 centered_spaced" >
    {{ 'generic.norecord' | translate }}
</div>